import type { CSSProperties } from "react";

/**
 * Extends React.CSSProperties to allow CSS custom properties (--var-name).
 */
type StyleWithVars = CSSProperties & {
    [key: `--${string}`]: string | number | undefined;
};

/**
 * Builds a `style` value that mixes standard CSS properties with CSS custom
 * properties (--var-name). The argument is checked against `StyleWithVars`, so
 * standard properties are still validated, while the returned value is a plain
 * `CSSProperties` the `style` prop accepts.
 *
 * Use instead of `style={{ "--foo": val } as any}`.
 */
export const styleWithVars = (style: StyleWithVars): CSSProperties => style;
